import '@babel/polyfill';
import React, { Fragment, lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import Router from 'next/router';
import Head from 'next/head';
import Block from '../adapters/helpers/Block';
import { customJsonstringify, getCanonicalURL, getReviewAndRatingId } from '../adapters/helpers/Utils';
import ImageFactory from '../adapters/cloudinary/ImageFactory';
import { setViewed } from '../persistence/recentlyViewed';
import contentfulClient from '../adapters/model/ContentfulClient';
import { MetaConstants } from '../adapters/helpers/Constants';
import { BazaarVoiceConstants } from '../adapters/helpers/Constants';
import { OrganizationConstants, ComponentFactoryConstants } from '../adapters/helpers/Constants';
import { addBVScript } from '../adapters/helpers/Utils';
import { addBVProductPageCallback } from '../adapters/helpers/Utils';
const Meta = lazy(() => import('../components/Meta/Meta'));
const GTMScriptFunction = lazy(() => import('../components/GTMScriptFunction'));
const Loader = lazy(() => import('../adapters/helpers/Loader'));
import ProductPageSEO from '../components/CustomerReviews/ProductSchema';
import DOMPurify from "isomorphic-dompurify";
class Product extends React.Component {
  componentDidMount() {
    var _this$props;
    const slug = (_this$props = this.props) == null ? void 0 : _this$props.slug;
    const product = this.getProduct();
    if (slug) {
      setViewed(slug);
    }
    Router.beforePopState(({
      as
    }) => {
      location.href = as;
    });
    addBVScript();
    addBVProductPageCallback(product.name);
    this.handleRatingandReviews();
  }
  static async getInitialProps({
    asPath
  }) {
    const client = await contentfulClient.getClient();
    const locales = await client.getLocales();
    const defaultLocale = locales.items.find(locale => locale.default);
    const countryCode = defaultLocale.code.slice(-2);
    const languageCode = defaultLocale.code.substring(0, 2);
    let baseProps = await this.initPage(asPath);
    baseProps.countryCode = countryCode;
    baseProps.languageCode = languageCode;
    return {
      ...baseProps
    };
  }
  static async initPage(slug) {
    var _newProducts$fields, _newProducts$fields$b, _newProducts$fields$b2, _newProducts$fields$b3, _newProducts$fields$b4, _newProducts$fields$b5, _newProducts$fields$b6, _newProducts$fields2, _newProducts$fields2$, _newProducts$fields2$2, _newProducts$fields2$3;
    let product = undefined;

    // Errors pages doesn't have a page entry in Contentful CMS

    if (slug) {
      const {
        default: productDao
      } = await import('../adapters/model/dao/ProductDao');
      product = await productDao.getActiveProductBySlug(slug);
    }
    let newProducts = product;
    newProducts == null ? void 0 : (_newProducts$fields = newProducts.fields) == null ? void 0 : (_newProducts$fields$b = _newProducts$fields.blocks) == null ? void 0 : (_newProducts$fields$b2 = _newProducts$fields$b[0]) == null ? void 0 : (_newProducts$fields$b3 = _newProducts$fields$b2.fields) == null ? void 0 : (_newProducts$fields$b4 = _newProducts$fields$b3.blocks) == null ? void 0 : (_newProducts$fields$b5 = _newProducts$fields$b4[1]) == null ? void 0 : (_newProducts$fields$b6 = _newProducts$fields$b5.fields) == null ? void 0 : _newProducts$fields$b6.blocks.map(blocksArr => {
      var _blocksArr$fields, _blocksArr$fields2, _blocksArr$fields2$ba;
      if ((blocksArr == null ? void 0 : (_blocksArr$fields = blocksArr.fields) == null ? void 0 : _blocksArr$fields.contentType) == ComponentFactoryConstants.ProductHighlights && (blocksArr == null ? void 0 : (_blocksArr$fields2 = blocksArr.fields) == null ? void 0 : (_blocksArr$fields2$ba = _blocksArr$fields2.background) == null ? void 0 : _blocksArr$fields2$ba.fields)) {
        blocksArr.fields.background.fields.isBannerImage = true;
      } else if (blocksArr.fields.devicesConfigurations) {
        blocksArr.fields.devicesConfigurations.map(devices => {
          if (devices.fields.backgroundAsset && devices.fields.backgroundAsset.fields) {
            devices.fields.backgroundAsset.fields.isBannerImage = true;
          }
        });
      }
    });
    if (newProducts == null ? void 0 : (_newProducts$fields2 = newProducts.fields) == null ? void 0 : (_newProducts$fields2$ = _newProducts$fields2.productOverview) == null ? void 0 : (_newProducts$fields2$2 = _newProducts$fields2$.fields) == null ? void 0 : (_newProducts$fields2$3 = _newProducts$fields2$2.mainAsset) == null ? void 0 : _newProducts$fields2$3.fields) {
      newProducts.fields.productOverview.fields.mainAsset.fields.isBannerImage = true;
    }
    return {
      'product': newProducts,
      'slug': slug
    };
  }
  constructor(props) {
    super(props);
    this.handleRatingandReviews = () => {
      var _this$props2, _this$props2$product, _this$props2$product$, _process$env$BAZAAR_V;
      const reviewAndRatingId = getReviewAndRatingId((_this$props2 = this.props) == null ? void 0 : (_this$props2$product = _this$props2.product) == null ? void 0 : (_this$props2$product$ = _this$props2$product.fields) == null ? void 0 : _this$props2$product$.productOverview);
      const requestOptions = {
        method: 'GET'
      };
      const RnRURL = (_process$env$BAZAAR_V = process.env.BAZAAR_VOICE_RNR) == null ? void 0 : _process$env$BAZAAR_V.replace('{reviewAndRatingId}', reviewAndRatingId);
      fetch(RnRURL, requestOptions).then(async response => {
        if (response.ok) {
          const result = await response.json();
          return result;
        }
      }).then(result => {
        var _result$reviewSummary, _result$reviewSummary2, _result$reviewSummary3;
        this.setState({
          rating: result == null ? void 0 : (_result$reviewSummary = result.reviewSummary) == null ? void 0 : (_result$reviewSummary2 = _result$reviewSummary.primaryRating) == null ? void 0 : _result$reviewSummary2.average,
          review: result == null ? void 0 : (_result$reviewSummary3 = result.reviewSummary) == null ? void 0 : _result$reviewSummary3.numReviews
        });
      }).catch(error => {
        console.error('Bazaar Voice RNR API: ', error);
      });
    };
    this.state = {
      rating: undefined,
      review: undefined
    };
  }
  /**
   * Rendering of the page. This always render the page using a common layout.
   *
   * Override the render method to do otherwise.
   *
   * @returns {*}
   */
  render() {
    var _this$props3, _this$props3$product, _this$props3$product$, _this$props3$product$2;
    let product = this.getProduct();
    let pagePath = product.productOverview.fields.slug.fields.slug;
    let productVariants = product.productOverview.fields.productVariants;
    let productVariant = {};
    if (productVariants) {
      productVariant = productVariants[0];
    }
    let metaData = this.getMetadata();
    if (metaData) {
      metaData.pageType = 'product';
    }
    return <Suspense fallback={<Loader />}>
            <Fragment>
            <Suspense fallback={<Loader />}>
                <Meta metadata={metaData} pagePath={pagePath} />
                <ProductPageSEO productDetails={(_this$props3 = this.props) == null ? void 0 : (_this$props3$product = _this$props3.product) == null ? void 0 : (_this$props3$product$ = _this$props3$product.fields) == null ? void 0 : (_this$props3$product$2 = _this$props3$product$.productOverview) == null ? void 0 : _this$props3$product$2.fields} pagePath={pagePath} rating={this.state.rating} review={this.state.review} />
            </Suspense>
                <Head>
                    {this.renderBazaarVoiceDynamicCatalogCollectionScript()}
                </Head>
                <div className='ob-wrapper'>
                <Suspense fallback={<Loader />}>{this.renderBody()}</Suspense>
                </div>
                <Suspense fallback={<Loader />}>
                <GTMScriptFunction languageCode={this.props.languageCode} countryCode={this.props.countryCode} productVariant={productVariant} />
                </Suspense>
            </Fragment>
            </Suspense>;
  }
  getProduct() {
    return this.props.product.fields;
  }
  getMetadata() {
    return this.props.product.fields.metadata.fields;
  }

  /**
   * By default, the page will render the modules of the Product.
   * Can be overridden on the child class to do specific rendering.
   * @returns {*|void}
   */
  renderBody() {
    var _this$props4, _this$props4$product, _this$props4$product$;
    return new Block(this.props.product).renderChildBlocks({
      extraAttributes: {
        entity: this.getProduct(),
        slug: this.props.slug,
        breadCrumbData: (_this$props4 = this.props) == null ? void 0 : (_this$props4$product = _this$props4.product) == null ? void 0 : (_this$props4$product$ = _this$props4$product.fields) == null ? void 0 : _this$props4$product$.breadcrumbs
      }
    });
  }
  getImageUrl(image) {
    var _image$fields, _image$fields$asset, _image$fields$asset$f, _image$fields$asset$f2;
    let contentImageId = image == null ? void 0 : (_image$fields = image.fields) == null ? void 0 : (_image$fields$asset = _image$fields.asset) == null ? void 0 : (_image$fields$asset$f = _image$fields$asset.fields) == null ? void 0 : (_image$fields$asset$f2 = _image$fields$asset$f.file) == null ? void 0 : _image$fields$asset$f2.url;
    let rendition = image.fields.imageRendition;
    let aspectRatio = rendition == null ? void 0 : rendition.fields.aspectRatio;
    let transformations = rendition == null ? void 0 : rendition.fields.transformations;
    let format = image.fields.forcedFormat || 'auto';
    let url = contentImageId && ImageFactory.buildContentfullImageUrlByWidth(contentImageId, aspectRatio, transformations, format);
    return url;
  }
  getBazaarVoiceImage(image) {
    var _image$fields2, _image$fields2$asset, _image$fields2$asset$, _image$fields2$asset$2;
    let contentImageUrl = image == null ? void 0 : (_image$fields2 = image.fields) == null ? void 0 : (_image$fields2$asset = _image$fields2.asset) == null ? void 0 : (_image$fields2$asset$ = _image$fields2$asset.fields) == null ? void 0 : (_image$fields2$asset$2 = _image$fields2$asset$.file) == null ? void 0 : _image$fields2$asset$2.url;
    let url = contentImageUrl && ImageFactory.buildContentfullImageUrlForBazaarVoice(contentImageUrl);
    return url;
  }
  renderBazaarVoiceDynamicCatalogCollectionScript() {
    var _product$productOverv, _product$productOverv2;
    let product = this.getProduct();
    let countryCode = this.props.countryCode;
    let imageUrl = this.getBazaarVoiceImage(product == null ? void 0 : (_product$productOverv = product.productOverview) == null ? void 0 : (_product$productOverv2 = _product$productOverv.fields) == null ? void 0 : _product$productOverv2.mainAsset);
    let productPageUrl = getCanonicalURL(product.productOverview.fields.slug.fields.slug, MetaConstants.https);
    let productVariants = product.productOverview.fields.productVariants;
    let skus = [];
    let eans = [];
    let reviewAndRatingId;
    if (productVariants) {
      for (let i = 0; i < productVariants.length; i++) {
        var _productVariant$field, _productVariant$field2;
        let productVariant = productVariants[i];
        let sku = productVariant == null ? void 0 : (_productVariant$field = productVariant.fields) == null ? void 0 : _productVariant$field.sku;
        let ean = productVariant == null ? void 0 : (_productVariant$field2 = productVariant.fields) == null ? void 0 : _productVariant$field2.ean;
        if (ean) {
          if (this.isValidBarcode(ean)) {
            if (ean.length == 13) {
              eans.push(ean);
            }
          }
        }
        if (sku) {
          if (this.isValidBarcode(sku)) {
            if (sku.length == 12) {
              skus.push(sku);
            }
            // EANs have been put in the SKU fields of product variant in contentful
            // add sku to ean list if sku is a ean code(length of 13).
            if (sku.length == 13) {
              if (!eans.includes(sku)) {
                eans.push(sku);
              }
            }
          }
        }
        if (productVariant.fields.isBazaarVoiceIdentifier) {
          var _productVariant$field3;
          reviewAndRatingId = productVariant == null ? void 0 : (_productVariant$field3 = productVariant.fields) == null ? void 0 : _productVariant$field3.bazaarVoiceId;
          // if reviewAndRatingId is null use sku/ean
          if (reviewAndRatingId === undefined) {
            if (sku) {
              reviewAndRatingId = sku;
            } else if (sku === undefined) {
              reviewAndRatingId = ean;
            }
            if (reviewAndRatingId === undefined) {
              var _productVariant$field4;
              console.error('No reviewAndRatingId specified for product variant Bazaar Voice identifier:', productVariant == null ? void 0 : (_productVariant$field4 = productVariant.fields) == null ? void 0 : _productVariant$field4.name);
            }
          }
        }
      }
    }

    // product
    let dccProduct = {
      'productId': reviewAndRatingId,
      'productName': product.name,
      'productDescription': product.productOverview.fields.description,
      'productImageURL': imageUrl,
      'productPageURL': productPageUrl,
      'brandName': OrganizationConstants.brand,
      'upcs': skus,
      'eans': eans
    };
    if (product.productOverview.fields.reviewAndRatingCategory) {
      dccProduct.categoryPath = [{
        'Name': product.productOverview.fields.reviewAndRatingCategory
      }];
    }

    // Catalog
    let catalogProducts = [];
    catalogProducts.push(dccProduct);

    // Family and Bazaar voice master product values
    let reviewAndRatingFamilyId = product.productOverview.fields.reviewAndRatingFamilyId;
    if (reviewAndRatingFamilyId) {
      let familyJson = [{
        'id': reviewAndRatingFamilyId,
        'expand': false
      }];
      dccProduct.families = familyJson;
      // Master product
      let masterProductId = getBazaarVoiceMasterProductId(reviewAndRatingFamilyId);
      let masterProductName = getBazaarVoiceMasterProductName(reviewAndRatingFamilyId);
      let masterProductJson = {
        'productId': masterProductId,
        'productName': masterProductName,
        'productPageURL': productPageUrl,
        'upcs': skus,
        'eans': eans,
        'families': [{
          'id': reviewAndRatingFamilyId,
          'expand': true
        }]
      };
      catalogProducts.push(masterProductJson);
    }
    let languageCode = this.props.languageCode;
    let bazaarVoiceLocale = languageCode + '_' + countryCode;
    let catalogProductsString = customJsonstringify(catalogProducts);
    let render;
    // do not render if we no productID
    if (reviewAndRatingId) {
      render = <Fragment>
                <script defer dangerouslySetInnerHTML={{
          __html: `window.bvDCC = {
                    catalogData: {
                            locale: '${bazaarVoiceLocale}',
                            catalogProducts: ${catalogProductsString}
                        }
                    };
                    window.bvCallback = function (BV) {
                      BV.pixel.trackEvent("CatalogUpdate", {
                         type: 'Product',
                         locale: window.bvDCC.catalogData.locale,
                         catalogProducts: window.bvDCC.catalogData.catalogProducts
                    });
                    };`
        }}>
                </script>
            </Fragment>;
    }
    return render;
  }
  isValidBarcode(barcode) {
    // check length
    if (barcode.length != 12 && barcode.length != 13) {
      return false;
    }
    var lastDigit = Number(barcode.substring(barcode.length - 1));
    var checkSum;
    if (isNaN(lastDigit)) {
      return false;
    } // not a valid upc/ean

    var arr = barcode.substring(0, barcode.length - 1).split('').reverse();
    var oddTotal = 0,
      evenTotal = 0;
    for (var i = 0; i < arr.length; i++) {
      if (isNaN(arr[i])) {
        return false;
      } // can't be a valid upc/ean we're checking for

      if (i % 2 == 0) {
        oddTotal += Number(arr[i]) * 3;
      } else {
        evenTotal += Number(arr[i]);
      }
    }
    checkSum = (10 - (evenTotal + oddTotal) % 10) % 10;

    // true if they are equal
    return checkSum == lastDigit;
  }
}
export function getBazaarVoiceMasterProductId(reviewAndRatingFamilyId) {
  let masterProductId = BazaarVoiceConstants.masterProductIdPrefix + reviewAndRatingFamilyId;
  return masterProductId;
}
export function getBazaarVoiceMasterProductName(reviewAndRatingFamilyId) {
  let masterProductName = BazaarVoiceConstants.masterProductNamePrefix + reviewAndRatingFamilyId;
  return masterProductName;
}
Product.propTypes = {
  product: PropTypes.object,
  countryCode: PropTypes.string,
  languageCode: PropTypes.string,
  slug: PropTypes.any,
  url: PropTypes.shape({
    asPath: PropTypes.string
  })
};
export default Product;